
import { Component, Prop, Vue } from 'vue-property-decorator'
import { BugService } from '@/services/index'

@Component({
    name: 'BugDialog'
})
export default class extends Vue {
    @Prop({ required: true, default: false }) private isVisible!: boolean
    @Prop({ required: true }) private newsId!: number 
    @Prop({ required: true }) private hide!: Function
    private bugForm: any = [{
        type: '', 
        memo: ''
    }]
    private bugTypeOptions = [
        { key: 1, value: '记者名抽取错误' },
        { key: 2, value: '漏抽记者名' },
        { key: 3, value: '分类问题' },
        { key: 4, value: '文章排版问题' },
        { key: 5, value: '标签抽取问题' },
        { key: 6, value: '转载识别问题' }
    ]

    private onBugTypeSelect() {
        let isAddBug = true 
        for (let i = 0, len = this.bugForm.length; i < len; i++) {
            if (!this.bugForm[i].type) {
                isAddBug = false 
            }
        }
        if (isAddBug) {
            const data = { type: '', memo: '' }
            this.bugForm.push(data)
        }
    }

    private async onSubmitBug() {
        const bugForm = this.bugForm.filter((bug: any) => {
            if (bug.type !== '') {
                return { type: bug.type, memo: bug.memo }
            }
        })
        const params = { news_id: this.newsId, data: bugForm }
        const result = await BugService.add(params)
        if (result.status === 200) {
            this.hide()
            this.$message({
                type: 'success',
                message: '提交成功!'
            })
        }
    }
    
    private onHide() {
        this.hide()
    }
}
